import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { formatInternational } from 'lib-shared-phone-numbers';
export function RoutedThroughForward({ node }) {
    return (_jsxs(_Fragment, { children: ["Forward \u00B7 To", ' ', _jsx("strong", { children: formatInternational(node.phone_number) || node.phone_number }), ' ', "(", node.call_pattern, ")"] }));
}
